import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import SEO from '../common/SEO';
import GoogleMaps from '../components/GoogleMaps';
import ServicesNavigationFooter from '../components/ServicesNavigationFooter';
import * as FiIcons from 'react-icons/fi';

const {FiBookOpen,FiChevronRight,FiShield,FiWind,FiZap,FiDollarSign,FiSearch,FiAlertTriangle,FiVolume2,FiCloud,FiThermometer,FiPieChart,FiLayers,FiHome,FiMicOff,FiTrendingUp,FiFileText,FiTool}=FiIcons;

function Topics() {
  const topics=[
    {
      title: "Spachtelarbeiten im Trockenbau – Fehler vermeiden | Experten-Check",
      description: "Risse an Deckenanschlüssen? Abhebende Farbe? 🛠️ Unsere Baustellen-Checkliste für Heinsberg deckt die häufigsten Fehler beim Spachteln auf.",
      link: "/blog/spachtelarbeiten-trockenbau-fehler-vermeiden",
      icon: FiTool,
      category: "Innenausbau & Praxis"
    },
    {
      title: "Schafwolle Dämmung – Vorteile & Nachteile | MK-AUSBAU",
      description: "Detaillierter Vergleich: Kosten,Brandschutz,Motten & Dämmwerte. Der Experten-Check für Bauherren in NRW.",
      link: "/blog/schafwolle-daemmung-vorteile-nachteile",
      icon: FiCloud,
      category: "Ökologische Baustoffe"
    },
    {
      title: "Schafwolle Dämmung: Natürlich & Nachhaltig",
      description: "Alles über Schafwolle als Dämmstoff. Einsatzgebiete,Herkunft und warum sie für gesundes Wohnen ideal ist.",
      link: "/blog/schafwolle-daemmung",
      icon: FiCloud,
      category: "Ökologische Baustoffe"
    },
    {
      title: "Trockenbau-Anfrage richtig stellen: Die Checkliste für schnelle Angebote",
      description: "So bekommen Sie Angebote ohne Rückfragen. Mit kopierbarer Muster-Vorlage für Ihre Anfrage!",
      link: "/blog/trockenbau-anfrage-richtig-stellen",
      icon: FiFileText,
      category: "Ratgeber & Checklisten",
    },
    {
      title: "Kellerdeckendämmung – sinnvoll oder überschätzt?",
      description: "Wann sie wirklich lohnt und wann andere Maßnahmen mehr bringen. Mit interaktivem Amortisations-Rechner!",
      link: "/blog/kellerdeckendaemmung",
      icon: FiTrendingUp,
      category: "Energie & Dämmung",
    },
    {
      title: "Kerndämmung: Schnelle Wärmedämmung ohne Baustelle",
      description: "Hohlwanddämmung für zweischaliges Mauerwerk. Ideal für Häuser im Kreis Heinsberg & NRW. Kosteneffizient & schnell.",
      link: "/blog/kerndaemmung",
      icon: FiShield,
      category: "Energie & Dämmung",
    },
    {
      title: "Unverbindliches Angebot für Trockenbau,Dämmung & Innenausbau",
      description: "Von Strohdämmung bis Glaswolle – regional stark in NRW. Ein seriöses Angebot beginnt immer mit einer realistischen Einschätzung.",
      link: "/blog/unverbindliches-angebot-innenausbau",
      icon: FiFileText,
      category: "Angebot & Service",
    },
    {
      title: "Gebäude mit eingeblasenem Stroh: Vom Feld zur Fertigung",
      description: "Warum diese natürliche Dämmung für den Mainstream bereit ist – auch in NRW. Kreislaufwirtschaft & CO2-Speicherung.",
      link: "/blog/stroh-einblasdaemmung",
      icon: FiCloud,
      category: "Ökologische Baustoffe",
    },
    {
      title: "Energetische Sanierung im Kreis Heinsberg: Von Effizienzklasse H auf A ohne 200.000 €",
      description: "Wie Hausbesitzer ihr Einfamilienhaus kosteneffizient sanieren. Hohlwanddämmung,Heizungsoptimierung & Co. im Praxis-Check.",
      link: "/blog/energetische-sanierung-heinsberg",
      icon: FiTrendingUp,
      category: "Sanierung & Effizienz",
    },
    {
      title: "Dachdämmung richtig planen: So sparst du massiv Heizkosten und vermeidest teure Fehler",
      description: "Dach dämmen oder Geschossdecke? 🏠 Anleitung für Steildächer,Einblasdämmung & Hitzeschutz. Vermeide diesen teuren 30%-Fehler!",
      link: "/blog/dachdaemmung-richtig-planen",
      icon: FiThermometer,
      category: "Energie & Dämmung",
    },
    {
      title: "Schallschutz im Trockenbau: Wie Sie Lärm effektiv aus Ihren Räumen fernhalten",
      description: "Ruhe im Haus! 🤫 Erfahren Sie,wie das Masse-Feder-Masse-Prinzip funktioniert und wie Sie Wände und Decken effektiv entkoppeln.",
      link: "/blog/schallschutz-trockenbau",
      icon: FiMicOff,
      category: "Bauphysik & Akustik",
    },
    {
      title: "Mieten oder Kaufen in Deutschland heute: Was Daten und Trends wirklich nahelegen",
      description: "Lohnt sich der Immobilienkauf 2026 noch? Ein datenbasierter Vergleich zwischen Eigenheim und Mieten + ETF-Sparplan unter Berücksichtigung der Zinswende.",
      link: "/blog/mieten-oder-kaufen",
      icon: FiHome,
      category: "Finanzen & Markt",
    },
    {
      title: "Was müssen Sie beim Trockenbau beachten? – Der komplette Praxisleitfaden",
      description: "Von Materialwahl über Schallschutz bis zu Kosten: Ein umfassender Guide für Bauherren und Profis für erfolgreiche Trockenbauprojekte.",
      link: "/blog/trockenbau-leitfaden",
      icon: FiLayers,
      category: "Innenausbau & Praxis"
    },
    {
      title: "Bau Kosten richtig abschätzen – Praxisleitfaden für Planer,Eigentümer und Investoren",
      description: "Wie Sie Baukosten fundiert kalkulieren,Risiken minimieren und Budgets einhalten. Ein Leitfaden für Planer und Investoren mit Checkliste.",
      link: "/blog/baukosten-abschaetzen",
      icon: FiPieChart,
      category: "Kosten & Planung"
    },
    {
      title: "Wie Sie mit moderner Dämmtechnik Energie sparen und den Wohnkomfort steigern",
      description: "Ein umfassender Ratgeber zu Materialien,Förderungen und der richtigen Strategie für Ihre Sanierung. Sparen Sie bis zu 70% Energie.",
      link: "/blog/moderne-daemmtechnik",
      icon: FiThermometer,
      category: "Energie & Dämmung"
    },
    {
      title: "Schallschutz bei Holzbalkendecken: Warum Mineralwolle allein ein Fehler ist",
      description: "Warum das Entfernen alter Schüttungen und der reine Einsatz von Mineralwolle den Schallschutz massiv verschlechtern kann – und wie man es richtig macht.",
      link: "/blog/schallschutz-holzbalkendecke",
      icon: FiVolume2,
      category: "Bauphysik & Akustik"
    },
    {
      title: "Kauft das bitte nicht – bevor ihr DAS getan habt!",
      description: "Professionelle Ankaufsprüfung bei sanierungsbedürftigen Mehrfamilienhäusern. Warum 'hässliche Entlein' oft die besten Deals sind.",
      link: "/blog/ankaufspruefung-mehrfamilienhaus",
      icon: FiSearch,
      category: "Ankaufsprüfung"
    },
    {
      title: 'Günstiger bauen statt über 3.000 €/m²: Low-Hanging-Fruits für wirtschaftliche Zinshäuser',
      description: 'Wo liegen die Hebel,um Baukosten massiv zu reduzieren? Ein Ratgeber zu TGA-Optimierung,Normabweichungen und smarten Planungslösungen.',
      link: '/blog/wirtschaftliches-bauen',
      icon: FiDollarSign,
      category: 'Wirtschaftlichkeit'
    },
    {
      title: 'Zweifach,dreifach oder vierfach verglaste Fenster 2026: Was lohnt sich wirklich?',
      description: 'Entscheidungshilfe für den Fenstertausch: Wann sich Dreifachverglasung amortisiert und warum Vierfachverglasung oft Overkill ist.',
      link: '/blog/fensterverglasung-2026',
      icon: FiZap,
      category: 'Energieeffizienz'
    },
    {
      title: 'Dampfbremse in der Holzdecke?',
      description: 'Warum eine Dampfbremse bei Holzkonstruktionen überlebenswichtig für die Bausubstanz ist und was Sie beachten müssen.',
      link: '/blog/dampfbremse-holzdecke',
      icon: FiWind,
      category: 'Dämmtechnik & Bauphysik'
    }
  ];

  return (
    <div className="py-20">
      <SEO 
        title="Blog & Ratgeber | Bauphysik,Sanierung & Wirtschaftlichkeit" 
        description="Expertenwissen von MK-AUSBAU: Ratgeber zu Schallschutz,Dämmung,Fenstern und wirtschaftlichem Bauen. ✅ Praxisnah & Verständlich." 
        keywords="Bau Blog,Sanierung Ratgeber,Schallschutz Tipps,Fensterverglasung Vergleich,Baukosten sparen,Ankaufsprüfung Checkliste,Mieten oder Kaufen" 
        canonical="/blog" 
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} className="text-center mb-16" >
          <div className="inline-flex items-center justify-center p-3 bg-mk-teal-100 rounded-xl mb-4">
            <SafeIcon icon={FiBookOpen} className="w-8 h-8 text-mk-teal-600" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Blog & Fachwissen
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Wir teilen unsere Expertise. Hier finden Sie wertvolle Informationen,Ratgeber und technische Hintergründe zu unseren Fachgebieten.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {topics.map((topic,index)=> (
            <motion.div key={topic.title} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{delay: index * 0.1}} viewport={{once: true}} >
              <Link to={topic.link} className="group block h-full bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col">
                <div className="p-8 flex-grow">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-xs font-bold text-mk-teal-600 uppercase tracking-wider bg-mk-teal-50 px-3 py-1 rounded-full">
                      {topic.category}
                    </span>
                    <SafeIcon icon={topic.icon} className="w-6 h-6 text-gray-400 group-hover:text-mk-teal-500 transition-colors" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-mk-teal-600 transition-colors leading-tight text-left">
                    {topic.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed text-sm text-left">
                    {topic.description}
                  </p>
                </div>
                <div className="px-8 py-6 bg-gray-50 border-t border-gray-100 flex items-center text-mk-red-700 font-bold group-hover:bg-mk-teal-50 transition-colors">
                  <span>Zum Artikel</span>
                  <SafeIcon icon={FiChevronRight} className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
      <ServicesNavigationFooter />
      <GoogleMaps />
    </div>
  );
}

export default Topics;